import { WorkflowStepCode } from '@exam-management/graphql';
import {
  CalendarTodayIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
  PersonOutlinedIcon,
  PersonRemoveOutlinedIcon,
} from '@shared/components';
import { useMemo } from 'react';

import { useQuestionReviewTaskDetails } from '../../providers';

export interface QuestionReviewSubtaskActionMenuProps {
  workflowStepCode: WorkflowStepCode;
  onRemoveReviewer: () => void;
  onChangeReviewer: () => void;
  onEditDueDate: () => void;
}

export default function QuestionReviewSubtaskActionMenu(
  props: Readonly<QuestionReviewSubtaskActionMenuProps>,
) {
  const { onRemoveReviewer, onChangeReviewer, onEditDueDate, workflowStepCode } = props;
  const { workflowRoles } = useQuestionReviewTaskDetails();

  const isTaskOwner = workflowRoles.isOwner;
  const isAssigner = workflowRoles.isAssigner;

  const shouldShowRemoveReviewer = isTaskOwner || isAssigner;

  const menuOptions: MoreMenuIconButtonOption[] = useMemo(() => {
    const options: MoreMenuIconButtonOption[] = [];

    switch (workflowStepCode) {
      case WorkflowStepCode.QuestionReviewTodo:
        if (shouldShowRemoveReviewer) {
          options.push({
            label: 'Change Reviewer',
            icon: <PersonOutlinedIcon />,
            onClick: onChangeReviewer,
          });
          options.push({
            label: 'Remove Reviewer',
            icon: <PersonRemoveOutlinedIcon />,
            onClick: onRemoveReviewer,
          });
          options.push({
            label: 'Edit Due Date',
            icon: <CalendarTodayIcon />,
            onClick: onEditDueDate,
          });
        }
        break;
      case WorkflowStepCode.QuestionReviewInReview:
        if (shouldShowRemoveReviewer) {
          options.push({
            label: 'Edit Due Date',
            icon: <CalendarTodayIcon />,
            onClick: onEditDueDate,
          });
        }
        break;
      case WorkflowStepCode.QuestionReviewReviewed:
        break;
      case WorkflowStepCode.QuestionReviewDone:
        break;
    }

    return options;
  }, [
    onRemoveReviewer,
    onChangeReviewer,
    onEditDueDate,
    workflowStepCode,
    isAssigner,
    isTaskOwner,
    shouldShowRemoveReviewer,
  ]);

  if (workflowStepCode === WorkflowStepCode.QuestionReviewDone) {
    return null;
  }

  if (menuOptions.length === 0) return null;

  return (
    <>
      <MoreMenuIconButton options={menuOptions} />
    </>
  );
}
